// extracted by mini-css-extract-plugin
export var cardFigure = "_9-0";
export var cardImage = "_9-2";
export var cardInner = "_9-1";
export var cardLabel = "_9-3";
export var cardPill = "_9-4";
export var cardPillActive = "_9-6";
export var cardPillSelfServe = "_9-7";
export var cardPillText = "_9-5";
export var pillGlow = "_9-8";
export var pillShimmer = "_9-9";